module.exports = __webpack_public_path__ + "static/media/cartaz-2.fd2f3886.png";